import { dataProps } from "@/models/data.model";
import { ComponentType, FC, JSX } from "react";

type Props = dataProps & {
  UI: ComponentType<dataProps>;
};

const EndscreenPage: FC<Props> = ({ UI, ...data }): JSX.Element => (
  <UI {...(data as dataProps)} />
);

export default EndscreenPage;
